module.exports = __webpack_public_path__ + "static/mustache-5fedaf670654289cbccf8e6bb9b308db.mp4";